import React from 'react'
import styled from 'styled-components'

const Md = styled.div`
  max-width: 40rem;
  margin: 0 auto;

  h1 {
    font-size: 48px;
    font-weight: 400;
    line-height: 1.1;
    margin: 0px;
    margin-bottom: 2rem;
    @media screen and (max-width: 50rem) {
      font-size: 30px;
    }
  }

  a {
    color: #1888FF;
  }
  
  ${props =>
    (props.location === '/' ||
      props.location === '/en' ||
      props.location === '/en/' ||
      props.location === '/fr' ||
      props.location === '/fr/') &&
    `
    max-width: none;
    width: 60vw;
    @media screen and (max-width: 50rem) {
      width: 100%;
    }
    h1 {
      font-size: 4.5vw;
      color: white;
      font-weight: 400;
      line-height: 1.1;
      text-shadow: 0 0 1.5rem rgba(0,0,0,0.5);
      @media screen and (max-width: 50rem) {
        font-size: 3rem;
      }
    }
    a {
      display: block;
      white-space: nowrap;
      cursor: pointer;
      color: white;
      margin-top: 2rem; 
      text-decoration: underline;
      &:disabled {
        opacity: 0.25;
      }
    }
  `}


  ${props =>
    (props.location === '/about' ||
      props.location === '/about/' ||
      props.location === '/about/en' ||
      props.location === '/about/en/' ||
      props.location === '/about/fr' ||
      props.location === '/about/fr/') &&
    `
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      color: #999;
      font-size: 1rem;
      padding: 1rem 0;
      margin-bottom: 0;
      &:not(:last-child) {
        border-bottom: 1px solid;
      }
      strong {
        color: #000;
        font-weight: 500;
      }
    }
  }
  `};

  img {
    max-width: 100%;
    height: auto;
  }

  .alignright {
    margin-left: 1rem;
    float: right;
    @media screen and (max-width: 50rem) {
      float: none;
      margin-left: 0
    }
  }
  .alignleft {
    margin-right: 1rem;
    float: left;
    @media screen and (max-width: 50rem) {
      float: none;
      margin-right: 0
    }
  }
  &::after {
    content: "";
    clear: both;
    display: table;

  div.coming-soon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme.colors.green};
    height: 20rem;
    width: 100%;
    border: 1px solid;
    position: relative;
    font-weight: 700;
    margin: 2rem 0;
    &::after {
      bottom: 0;
      top: 0;
      left: 0;
      right: 0;
      content: '';
      position: absolute;
      background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' width='90' height='90' viewBox='0 0 90 90'><path fill='none' stroke='#388e3c' stroke-width='0.25%'  strokeLinecap='square' d='M0,0 L90,90'/><path fill='none' stroke='#388e3c' stroke-width='0.25%'  strokeLinecap='square' d='M90,0 L0,90'/></svg>")
        no-repeat;
      background-size: 100% 100%;
    }
  }
  
  ${props =>
    (props.location === '/' ||
      props.location === '/en' ||
      props.location === '/en/' ||
      props.location === '/fr' ||
      props.location === '/fr/') &&
    `
    max-width: none;
    width: 60vw;
    h1 {
      font-size: 4.5vw;
      color: white;
      font-weight: 400;
      line-height: 1.1;
      text-shadow: 0 0 1.5rem rgba(0,0,0,0.5);
    }
    a {
      display: block;
      white-space: nowrap;
      cursor: pointer;
      color: white;
      margin-top: 2rem; 
      text-decoration: underline;
      &:disabled {
        opacity: 0.25;
      }
    }
    `}

  
`

export const HTMLContent = ({ content, className, location }) => (
  <Md
    className={className}
    location={location}
    dangerouslySetInnerHTML={{ __html: content }}
  />
)

const Content = ({ content, className }) => (
  <div className={className}>{content}</div>
)

export default Content



// WEBPACK FOOTER //
// ./src/components/Content.js